import { Injectable } from '@angular/core';

import { Pagination } from 'src/app/core/models/dynamic-table/pagination.model';
import {
  ComparisonObject,
  ComparisonObjectsWithLogicalOperators,
} from '../api/models';
import { Orders } from '../models/dynamic-table/order.model';

@Injectable({
  providedIn: 'root',
})
export class DynamicTableService {
  constructor() {}

  getPaginationData(data, model: Pagination): Pagination {
    model.totalPages = data?.totalPages;
    model.totalCount = data?.totalCount;
    model.pageIndex = data?.pageNumber;
    model.hasNextPage = data?.hasNextPage;
    model.hasPreviousPage = data?.hasPreviousPage;
    model.firstIndex = (model.pageIndex - 1) * model.pageSize + 1;
    if (model.firstIndex == 0) model.firstIndex = 1;

    return model;
  }

  // TODO NEW SEARCH Delete this method because this is for old infrastructure
  checkComparisonObject(
    comparisonObject: ComparisonObject[],
    newComparisonObject: ComparisonObject[],
    multiOperator: boolean = true
  ): ComparisonObject[] {
    newComparisonObject.forEach((comparison) => {
      let comparisonSearched;
      let comparisonIndexSearched;

      if (multiOperator) {
        comparisonSearched = comparisonObject?.find((item) => {
          return (
            item.field === comparison.field &&
            item.operator == comparison.operator
          );
        });
        comparisonIndexSearched = comparisonObject?.findIndex((item) => {
          return (
            item.field === comparison.field &&
            item.operator == comparison.operator
          );
        });
      } else {
        comparisonSearched = comparisonObject?.find((item) => {
          return item.field === comparison.field;
        });
        comparisonIndexSearched = comparisonObject?.findIndex((item) => {
          return item.field === comparison.field;
        });
      }

      //edit or delete
      if (comparisonSearched) {
        //edit
        if (comparison?.value || comparison?.value == '0') {
          comparisonSearched.operator = comparison?.operator;
          comparisonSearched.value = comparison?.value;
        } //delete
        else comparisonObject.splice(comparisonIndexSearched, 1);
      } else if (comparison.value || comparison.value == '0')
        //add
        comparisonObject.push(comparison);
    });

    return comparisonObject.filter((item) => item.value || item.value == '0');
  }

  checkComparisonObjects(
    savedComparisonObjects: ComparisonObjectsWithLogicalOperators[],
    newComparisonObject: ComparisonObjectsWithLogicalOperators,
    multiOperator: boolean = true
  ): ComparisonObjectsWithLogicalOperators[] {
    newComparisonObject.comparisonObjects.forEach((comparison) => {
      let parentObjectIndex;
      let searchedComparison;
      let searchedComparisonIndex;

      if (multiOperator)
        savedComparisonObjects.forEach((item, index) => {
          if (!searchedComparison) {
            searchedComparison = item.comparisonObjects?.find((item) => {
              return (
                item.field === comparison.field &&
                item.operator == comparison.operator
              );
            });
            searchedComparisonIndex = item.comparisonObjects?.findIndex(
              (item) => {
                return (
                  item.field === comparison.field &&
                  item.operator == comparison.operator
                );
              }
            );
            if (searchedComparison) parentObjectIndex = index; //get parent
          }
        });
      else
        savedComparisonObjects.forEach((item, index) => {
          if (!searchedComparison) {
            searchedComparison = item.comparisonObjects?.find((item) => {
              return item.field === comparison.field;
            });
            searchedComparisonIndex = item.comparisonObjects?.findIndex(
              (item) => {
                return item.field === comparison.field;
              }
            );
            if (searchedComparison) parentObjectIndex = index; //get parent
          }
        });

      //edit or delete
      if (searchedComparison) {
        //edit
        if (comparison?.value || comparison?.value == '0') {
          searchedComparison.operator = comparison?.operator;
          searchedComparison.value = comparison?.value;
        }
        //delete
        else {
          savedComparisonObjects[parentObjectIndex].comparisonObjects.splice(
            searchedComparisonIndex,
            1
          );
          if (
            !savedComparisonObjects[parentObjectIndex].comparisonObjects.length
          )
            savedComparisonObjects.splice(parentObjectIndex, 1);
        }
      }
      //add
      else if (comparison.value || comparison.value == '0') {
        if (newComparisonObject.logicalComparisonOperator == null)
          delete newComparisonObject.logicalComparisonOperator;
        savedComparisonObjects.push(newComparisonObject);
      }
    });

    // return comparisonObjects.filter((item) => item.value || item.value == '0');
    return savedComparisonObjects;
  }

  addOrRemoveComparisonObject(
    savedComparisonObjects: ComparisonObjectsWithLogicalOperators[],
    newComparisonObject: ComparisonObjectsWithLogicalOperators,
    fieldName: string
  ): ComparisonObjectsWithLogicalOperators[] {
    // first delete
    savedComparisonObjects.forEach((item, index) => {
      if (item.comparisonObjects.find((obj) => obj.field == fieldName))
        savedComparisonObjects.splice(index, 1);
    });

    //add
    newComparisonObject.comparisonObjects =
      newComparisonObject?.comparisonObjects?.filter(
        (item) => item.value || item.value == '0'
      );
    if (newComparisonObject.comparisonObjects?.length)
      savedComparisonObjects.push(newComparisonObject);

    return savedComparisonObjects;
  }

  checkSortObject(sortModels: Orders[], sortItem: Orders): Orders[] {
    let item = sortModels?.find((item) => {
      return item.columnName === sortItem.columnName;
    });
    let indexItem = sortModels?.findIndex((item) => {
      return item.columnName === sortItem.columnName;
    });

    //edit or delete
    if (item) {
      if (sortItem.sort)
        //edit
        sortModels[indexItem].sort = sortItem.sort;

      if (!sortItem.sort)
        //delete
        sortModels.splice(indexItem, 1);
    } else {
      //add
      sortModels.push(sortItem);
    }

    return sortModels;
  }
}
